import {
  acquisitionInvestorsCapitalInvestedAtom,
  acquisitionInvestorsDollarCommonEquityEquityMethodAtom,
  acquisitionInvestorsDollarPreferredEquityEquityMethodAtom,
  acquisitionInvestorsDollarPreferredEquityProjectCostMethodAtom,
  acquisitionInvestorsInitialPercentPreferredEquityProjectCostMethodAtom,
  acquisitionInvestorsPercentCommonEquityAtom,
  acquisitionInvestorsPercentCommonEquityEquityMethodAtom,
  acquisitionInvestorsPercentCommonEquityProjectCostMethodAtom,
  acquisitionInvestorsPercentPreferredEquityAtom,
  acquisitionInvestorsPercentPreferredEquityEquityMethodAtom,
  acquisitionInvestorsPercentPreferredEquityProjectCostMethodAtom,
  acquisitionInvestorsPrePromotePercentCommonEquityEquityMethodAtom,
  coInvestorsPercentPreferredEquityAtom,
  commonEquityTotalDollarValueEquityMethodAtom,
  postPromoteCommonEquityDollarEquityMethodAtom,
  prePromoteCommonEquityDollarEquityMethodAtom,
  preferredEquityTotalDollarValueEquityMethodAtom,
  preferredEquityTotalInitialPercentProjectCostMethodAtom,
  preferredEquityTotalPercentProjectCostMethodAtom,
  promoteSearchersCarryDollarCommonEquityEquityMethodAtom,
  promoteSearchersCarryPercentCommonEquityAtom,
  promoteSearchersCarryPercentCommonEquityEquityMethodAtom,
  promoteSearchersCarryPercentCommonEquityProjectCostMethodAtom,
  searchPhaseInvestorsCapitalInvestedAtom,
  searchPhaseInvestorsDollarCommonEquityEquityMethodAtom,
  searchPhaseInvestorsDollarPreferredEquityEquityMethodAtom,
  searchPhaseInvestorsDollarPreferredEquityProjectCostMethodAtom,
  searchPhaseInvestorsInitialPercentPreferredEquityProjectCostMethodAtom,
  searchPhaseInvestorsPercentCommonEquityAtom,
  searchPhaseInvestorsPercentCommonEquityEquityMethodAtom,
  searchPhaseInvestorsPercentCommonEquityProjectCostMethodAtom,
  searchPhaseInvestorsPercentPreferredEquityAtom,
  searchPhaseInvestorsPercentPreferredEquityEquityMethodAtom,
  searchPhaseInvestorsPercentPreferredEquityProjectCostMethodAtom,
  searchPhaseInvestorsPrePromotePercentCommonEquityEquityMethodAtom,
  searcherCoInvestCapitalInvestedAtom,
  searcherCoInvestDollarCommonEquityEquityMethodAtom,
  searcherCoInvestDollarPreferredEquityEquityMethodAtom,
  searcherCoInvestDollarPreferredEquityProjectCostMethodAtom,
  searcherCoInvestInitialPercentPreferredEquityProjectCostMethodAtom,
  searcherCoInvestPercentCommonEquityAtom,
  searcherCoInvestPercentCommonEquityEquityMethodAtom,
  searcherCoInvestPercentCommonEquityProjectCostMethodAtom,
  searcherCoInvestPercentPreferredEquityEquityMethodAtom,
  searcherCoInvestPercentPreferredEquityProjectCostMethodAtom,
  searcherCoInvestPrePromotePercentCommonEquityEquityMethodAtom,
  sellerRolloverCapitalInvestedAtom,
  sellerRolloverDollarCommonEquityEquityMethodAtom,
  sellerRolloverDollarPreferredEquityEquityMethodAtom,
  sellerRolloverDollarPreferredEquityProjectCostMethodAtom,
  sellerRolloverInitialPercentPreferredEquityProjectCostMethodAtom,
  sellerRolloverPercentCommonEquityAtom,
  sellerRolloverPercentCommonEquityEquityMethodAtom,
  sellerRolloverPercentCommonEquityProjectCostMethodAtom,
  sellerRolloverPercentPreferredEquityAtom,
  sellerRolloverPercentPreferredEquityEquityMethodAtom,
  sellerRolloverPercentPreferredEquityProjectCostMethodAtom,
  sellerRolloverPrePromotePercentCommonEquityEquityMethodAtom,
} from "@/financeModels/owasco/companyOwnership";
import { modals } from "@mantine/modals";

import { useAtomValue } from "jotai";
// prettier-ignore
const allAtoms = [
  ["searchPhaseInvestorsCapitalInvestedAtom",searchPhaseInvestorsCapitalInvestedAtom],
  ["acquisitionInvestorsCapitalInvestedAtom",acquisitionInvestorsCapitalInvestedAtom],
  ["searcherCoInvestCapitalInvestedAtom",searcherCoInvestCapitalInvestedAtom],
  ["sellerRolloverCapitalInvestedAtom",sellerRolloverCapitalInvestedAtom],
  ["searchPhaseInvestorsDollarPreferredEquityEquityMethodAtom",searchPhaseInvestorsDollarPreferredEquityEquityMethodAtom],
  ["acquisitionInvestorsDollarPreferredEquityEquityMethodAtom",acquisitionInvestorsDollarPreferredEquityEquityMethodAtom],
  ["searcherCoInvestDollarPreferredEquityEquityMethodAtom",searcherCoInvestDollarPreferredEquityEquityMethodAtom],
  ["sellerRolloverDollarPreferredEquityEquityMethodAtom",sellerRolloverDollarPreferredEquityEquityMethodAtom],
  ["preferredEquityTotalDollarValueEquityMethodAtom",preferredEquityTotalDollarValueEquityMethodAtom],
  ["searchPhaseInvestorsPercentPreferredEquityEquityMethodAtom",searchPhaseInvestorsPercentPreferredEquityEquityMethodAtom],
  ["acquisitionInvestorsPercentPreferredEquityEquityMethodAtom",acquisitionInvestorsPercentPreferredEquityEquityMethodAtom],
  ["searcherCoInvestPercentPreferredEquityEquityMethodAtom",searcherCoInvestPercentPreferredEquityEquityMethodAtom],
  ["sellerRolloverPercentPreferredEquityEquityMethodAtom",sellerRolloverPercentPreferredEquityEquityMethodAtom],
  ["searchPhaseInvestorsDollarCommonEquityEquityMethodAtom",searchPhaseInvestorsDollarCommonEquityEquityMethodAtom],
  ["acquisitionInvestorsDollarCommonEquityEquityMethodAtom",acquisitionInvestorsDollarCommonEquityEquityMethodAtom],
  ["searcherCoInvestDollarCommonEquityEquityMethodAtom",searcherCoInvestDollarCommonEquityEquityMethodAtom],
  ["sellerRolloverDollarCommonEquityEquityMethodAtom",sellerRolloverDollarCommonEquityEquityMethodAtom],
  ["promoteSearchersCarryDollarCommonEquityEquityMethodAtom",promoteSearchersCarryDollarCommonEquityEquityMethodAtom],
  ["prePromoteCommonEquityDollarEquityMethodAtom",prePromoteCommonEquityDollarEquityMethodAtom],
  ["postPromoteCommonEquityDollarEquityMethodAtom",postPromoteCommonEquityDollarEquityMethodAtom],
  ["commonEquityTotalDollarValueEquityMethodAtom",commonEquityTotalDollarValueEquityMethodAtom],
  ["searchPhaseInvestorsPrePromotePercentCommonEquityEquityMethodAtom", searchPhaseInvestorsPrePromotePercentCommonEquityEquityMethodAtom],
  ["acquisitionInvestorsPrePromotePercentCommonEquityEquityMethodAtom",acquisitionInvestorsPrePromotePercentCommonEquityEquityMethodAtom],
  ["searcherCoInvestPrePromotePercentCommonEquityEquityMethodAtom",searcherCoInvestPrePromotePercentCommonEquityEquityMethodAtom],
  ["sellerRolloverPrePromotePercentCommonEquityEquityMethodAtom",sellerRolloverPrePromotePercentCommonEquityEquityMethodAtom],
  ["searchPhaseInvestorsPercentCommonEquityEquityMethodAtom",searchPhaseInvestorsPercentCommonEquityEquityMethodAtom],
  ["acquisitionInvestorsPercentCommonEquityEquityMethodAtom",acquisitionInvestorsPercentCommonEquityEquityMethodAtom],
  ["searcherCoInvestPercentCommonEquityEquityMethodAtom",searcherCoInvestPercentCommonEquityEquityMethodAtom],
  ["sellerRolloverPercentCommonEquityEquityMethodAtom",sellerRolloverPercentCommonEquityEquityMethodAtom],
  ["promoteSearchersCarryPercentCommonEquityEquityMethodAtom",promoteSearchersCarryPercentCommonEquityEquityMethodAtom],
  ["searchPhaseInvestorsDollarPreferredEquityProjectCostMethodAtom",searchPhaseInvestorsDollarPreferredEquityProjectCostMethodAtom],
  ["acquisitionInvestorsDollarPreferredEquityProjectCostMethodAtom",acquisitionInvestorsDollarPreferredEquityProjectCostMethodAtom],
  ["searcherCoInvestDollarPreferredEquityProjectCostMethodAtom",searcherCoInvestDollarPreferredEquityProjectCostMethodAtom],
  ["sellerRolloverDollarPreferredEquityProjectCostMethodAtom",sellerRolloverDollarPreferredEquityProjectCostMethodAtom],
  ["searchPhaseInvestorsInitialPercentPreferredEquityProjectCostMethodAtom",searchPhaseInvestorsInitialPercentPreferredEquityProjectCostMethodAtom],
  ["acquisitionInvestorsInitialPercentPreferredEquityProjectCostMethodAtom",acquisitionInvestorsInitialPercentPreferredEquityProjectCostMethodAtom],
  ["searcherCoInvestInitialPercentPreferredEquityProjectCostMethodAtom",searcherCoInvestInitialPercentPreferredEquityProjectCostMethodAtom],
  ["sellerRolloverInitialPercentPreferredEquityProjectCostMethodAtom",sellerRolloverInitialPercentPreferredEquityProjectCostMethodAtom],
  ["preferredEquityTotalInitialPercentProjectCostMethodAtom",preferredEquityTotalInitialPercentProjectCostMethodAtom],
  ["searchPhaseInvestorsPercentPreferredEquityProjectCostMethodAtom",searchPhaseInvestorsPercentPreferredEquityProjectCostMethodAtom],
  ["acquisitionInvestorsPercentPreferredEquityProjectCostMethodAtom",acquisitionInvestorsPercentPreferredEquityProjectCostMethodAtom],
  ["searcherCoInvestPercentPreferredEquityProjectCostMethodAtom",searcherCoInvestPercentPreferredEquityProjectCostMethodAtom],
  ["sellerRolloverPercentPreferredEquityProjectCostMethodAtom",sellerRolloverPercentPreferredEquityProjectCostMethodAtom],
  ["preferredEquityTotalPercentProjectCostMethodAtom",preferredEquityTotalPercentProjectCostMethodAtom],
  ["searchPhaseInvestorsPercentCommonEquityProjectCostMethodAtom",searchPhaseInvestorsPercentCommonEquityProjectCostMethodAtom],
  ["acquisitionInvestorsPercentCommonEquityProjectCostMethodAtom",acquisitionInvestorsPercentCommonEquityProjectCostMethodAtom],
  ["searcherCoInvestPercentCommonEquityProjectCostMethodAtom",searcherCoInvestPercentCommonEquityProjectCostMethodAtom],
  ["sellerRolloverPercentCommonEquityProjectCostMethodAtom",sellerRolloverPercentCommonEquityProjectCostMethodAtom],
  ["promoteSearchersCarryPercentCommonEquityProjectCostMethodAtom",promoteSearchersCarryPercentCommonEquityProjectCostMethodAtom],
  ["searchPhaseInvestorsPercentPreferredEquityAtom",searchPhaseInvestorsPercentPreferredEquityAtom],
  ["acquisitionInvestorsPercentPreferredEquityAtom",acquisitionInvestorsPercentPreferredEquityAtom],
  ["coInvestorsPercentPreferredEquityAtom",coInvestorsPercentPreferredEquityAtom],
  ["sellerRolloverPercentPreferredEquityAtom",sellerRolloverPercentPreferredEquityAtom],
  ["searchPhaseInvestorsPercentCommonEquityAtom",searchPhaseInvestorsPercentCommonEquityAtom],
  ["acquisitionInvestorsPercentCommonEquityAtom",acquisitionInvestorsPercentCommonEquityAtom],
  ["searcherCoInvestPercentCommonEquityAtom",searcherCoInvestPercentCommonEquityAtom],
  ["sellerRolloverPercentCommonEquityAtom",sellerRolloverPercentCommonEquityAtom],
  ["promoteSearchersCarryPercentCommonEquityAtom",promoteSearchersCarryPercentCommonEquityAtom],
] as const

export const openDebugOwnershipTablesModal = () =>
  modals.openConfirmModal({
    title: "Please confirm your action",
    children: <DebugOwnershipTables />,
    labels: { confirm: "Confirm", cancel: "Cancel" },
    onCancel: () => console.log("Cancel"),
    onConfirm: () => console.log("Confirmed"),
    size: "xl",
  });

export const DebugOwnershipTables = () => {
  const values = allAtoms.map(([name, atom]) => ({
    name,
    // eslint-disable-next-line react-hooks/rules-of-hooks
    value: useAtomValue(atom),
  }));

  return (
    <div>
      {values.map(({ name, value }) => (
        <div
          key={name}
          style={{
            display: "flex",
            gap: 4,
            marginBottom: 8,
            fontFamily: "monospace",
            justifyContent: "space-between",
          }}
        >
          <HighlightWords
            text={name}
            wordsToHighlight={[
              { word: "PreferredEquity", color: "blue" },
              { word: "CommonEquity", color: "green" },
              { word: "ProjectCost", color: "orange" },
              { word: "EquityMethod", color: "red" },
            ]}
          />
          <div>{JSON.stringify(value)}</div>
        </div>
      ))}
    </div>
  );
};

export const formatMoney = (n: number) =>
  `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
export const formatPercent = (n: number) => `${(n * 100).toFixed(2)}%`;

//react component to highlight words in a string
// take an array of word color pairs to highlight
export const HighlightWords = ({
  text,
  wordsToHighlight,
}: {
  text: string;
  wordsToHighlight: Array<{ word: string; color: string }>;
}) => {
  const highlightedText = wordsToHighlight.reduce((acc, { word, color }) => {
    const regex = new RegExp(`(${word})`, "gi");
    return acc.replace(regex, `<span style="color: ${color}">$1</span>`);
  }, text);

  return <div dangerouslySetInnerHTML={{ __html: highlightedText }} />;
};
